// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpAnchoredRegion } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const AnchoredRegion = wrap(jpAnchoredRegion());
// @ts-expect-error unknown property
AnchoredRegion.displayName = 'Jupyter.AnchoredRegion';
